
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"18","height":"14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 1.125l-9 6.75-9-6.75C0 .815.11.549.33.33.55.11.814 0 1.125 0h15.75c.31 0 .576.11.795.33.22.22.33.484.33.795zM0 3.146l9 6.75 9-6.75v9.229c0 .31-.11.576-.33.795-.22.22-.484.33-.795.33H1.125c-.31 0-.576-.11-.795-.33-.22-.22-.33-.484-.33-.795V3.146z"}})])
      }
    
      }
    